import React from 'react'
import { Link } from 'react-router-dom';
import img1 from './layout/assets/img/applicationCS.jpg';
import img2 from './layout/assets/img/desarrolloweb.jpg';
import img3 from './layout/assets/img/api.jpg';
import img4 from './layout/assets/img/testing.jpg';

export const Inicio = () => {
  return (
    <div>
      <main>
        <h1 className='initial__title'>Web Desginer & Project Manager</h1>

        <h3 className='initial__subtitle'>I can help to create applications, API, web pages using different programing languages or just manage the project, I work as freelance. <Link to='/contacto'>Hire Me Now</Link></h3>
        <section className='work__list'>
          <ul>
            <li>Clien server application</li>
            <li>Web Applications</li>
            <li>API Rest</li>
            <li>Test execution</li>
          </ul>
        </section>

        <section className='portfolio__gallery'>
          <figure className="gallery__item">
            <div class="gallery__container-image">
              <a href="https://enriquediazweb.com/services/" target="_blank">
                <img src={img1} alt="type 1" class="gallery__image"/>
              </a>
            </div>
            <figcaption class="gallery__title">Cliente server applications</figcaption>
            <i class="gallery__icon fa-brands fa-python"></i>
            <span class="gallery__category">python / c#</span>
            <span>Application that can perform specific functions and works inside of a network enviroment</span>
          </figure>
          <figure className="gallery__item">
            <div class="gallery__container-image">
              <a href="https://portafolio.enriquediazweb.com/agencia/index.html" target="_blank">
                <img src={img2} alt="type 1" class="gallery__image"/>
              </a>
            </div>
            <figcaption class="gallery__title">Wep Applications</figcaption>
            <i class="gallery__icon fa-solid fa-window-restore"></i>
            <span class="gallery__category">web</span>
            <span>Web applications are designed in a specific language depending on the required functionality</span>
          </figure>
          <figure className="gallery__item">
            <div class="gallery__container-image">
              <a href="https://enriquediazweb.com/services/" target="_blank">
                <img src={img3} alt="type 1" class="gallery__image"/>
              </a>
            </div>
            <figcaption class="gallery__title">API Rest</figcaption>
            <i class="gallery__icon fa-brands fa-node"></i>
            <span class="gallery__category">API</span>
            <span>Publish access functionality to the database or service, through an API that displays, receives or stores data</span>
          </figure>
          <figure className="gallery__item">
            <div class="gallery__container-image">
              <a href="https://enriquediazweb.com/services/" target="_blank">
                <img src={img4} alt="type 1" class="gallery__image"/>
              </a>
            </div>
            <figcaption class="gallery__title">Execution tests</figcaption>
            <i class="gallery__icon fa-brands fa-chrome"></i>
            <span class="gallery__category">test automation</span>
            <span>Security, black box, or negative testing depending on the need</span>
          </figure>
        </section>
      </main>
    </div>
  )
}
